module.exports = __webpack_public_path__ + "static/media/Hello.ce9b13e5.jpg";